(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("sticky", [], factory);
	else if(typeof exports === 'object')
		exports["sticky"] = factory();
	else
		root["sticky"] = factory();
})(this, function() {
return 